import { render, staticRenderFns } from "./RegulationsTab.vue?vue&type=template&id=61eed944&scoped=true"
import script from "./RegulationsTab.vue?vue&type=script&lang=js"
export * from "./RegulationsTab.vue?vue&type=script&lang=js"
import style0 from "./RegulationsTab.vue?vue&type=style&index=0&id=61eed944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eed944",
  null
  
)

export default component.exports